function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, useState, useCallback } from 'react';
import { TextInput, ITextInputProps } from '../TextInput';
import { Button } from '../Button';
import { Icon } from '../Icon';
require("./PasswordInput.css");
var styles = {
  "Button": "PasswordInput-module-Button_2rn",
  "Icon": "PasswordInput-module-Icon_3A2",
  "errorState": "PasswordInput-module-errorState_p1m"
};
export const PasswordInput = ({
  showPassButton = false,
  ...props
}) => {
  const [typeInput, setTypeInput] = useState('password');
  const handleShowPass = useCallback(() => {
    if (typeInput === 'password') {
      setTypeInput('text');
    } else {
      setTypeInput('password');
    }
  }, [typeInput]);
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    className: styles[`${props.state}State`],
    type: typeInput,
    addonAfter: showPassButton ? /*#__PURE__*/React.createElement(Button, {
      size: "s",
      theme: "transparent",
      className: styles.Button,
      onClick: handleShowPass,
      "aria-label": typeInput === 'text' ? 'скрыть пароль' : 'показать пароль'
    }, /*#__PURE__*/React.createElement(Icon, {
      className: styles.Icon,
      name: typeInput === 'text' ? 'eye' : 'eyeClose',
      size: "m"
    })) : null
  }));
};